import { render, staticRenderFns } from "./STBHio.vue?vue&type=template&id=0f66412f&scoped=true"
import script from "./STBHio.vue?vue&type=script&lang=js"
export * from "./STBHio.vue?vue&type=script&lang=js"
import style0 from "./STBHio.vue?vue&type=style&index=0&id=0f66412f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66412f",
  null
  
)

export default component.exports